var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyConversation = function SvgEmptyConversation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3828 60.0273H57.3036C59.3889 60.0273 61.0941 58.322 61.0941 56.2326C61.0941 54.1469 59.3889 52.4415 57.3036 52.4415",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3325 66.6719H54.3827C56.2082 66.6719 57.7026 65.1773 57.7026 63.3477C57.7026 61.5218 56.2082 60.0271 54.3827 60.0271H46.5195",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4629 44.8517H57.3033C59.3886 44.8517 61.0938 46.5609 61.0938 48.6466C61.0938 50.7321 59.3886 52.4414 57.3033 52.4414H46.5193",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4623 44.8516C44.3808 44.8516 42.6719 43.1461 42.6719 41.0606C42.6719 38.9712 44.3771 37.2657 46.4623 37.2657",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5189 52.4414C44.4373 52.4414 42.7285 50.7322 42.7285 48.6466C42.7285 46.561 44.4336 44.8517 46.5189 44.8517",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5189 60.0273C44.4373 60.0273 42.7285 58.322 42.7285 56.2326C42.7285 54.1469 44.4336 52.4415 46.5189 52.4415",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5191 66.6719C44.6973 66.6719 43.1992 65.1773 43.1992 63.3477C43.1992 61.5218 44.6936 60.0271 46.5191 60.0271",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90625 43.6364V36.6304C6.90625 34.9098 8.31406 33.4981 10.038 33.4981H15.8684C17.5923 33.4981 19.004 34.9098 19.004 36.6304V62.5691C19.004 64.2895 17.5923 65.7012 15.8684 65.7012H10.038C8.31778 65.7012 6.90625 64.2932 6.90625 62.5691V55.5629",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0039 61.9321H22.9713C26.197 61.9321 25.064 61.8756 26.581 63.8972C27.8118 65.5424 31.128 66.6719 33.3186 66.6719H54.1829",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3032 44.8516C59.3847 44.8516 61.0936 43.1461 61.0936 41.0606C61.0936 38.9712 59.3885 37.2657 57.3032 37.2657H40.3762C39.5707 37.2657 39.2433 37.0322 39.6122 36.0835C41.1969 31.9989 42.8303 25.6026 40.2256 21.6347C39.2019 20.0762 38.3211 19.2065 36.7628 18.0508C35.3587 17.008 34.4817 16.8949 34.0828 19.5378C33.3713 24.2136 31.4253 37.2657 23.054 37.2657H19.0039",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5457 42.2204C35.2007 46.9941 32.7427 51.0826 25.8281 51.9785",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1758 8.80078V1.32782",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5039 11.8965L50.6218 5.69228",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8463 11.8965L21.7246 5.69228",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90625 49.6074V49.6002",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEmptyConversation;